module.exports = __webpack_public_path__ + "static/media/Crossley Kitchen Fridge Unit (4).3f5e29e9.jpg";